import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";

@Component({
    selector: 'app-btech-cse-specialisations',
    templateUrl: './btech-cse-specialisations.component.html',
    styleUrls: ['./btech-cse-specialisations.component.scss']
})
export class BtechCseSpecialisationsComponent implements OnInit {
    pageTitle: string;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
    ) {
        this.route.data.subscribe(params => {
            if (params && params.title) {
                this.pageTitle = params.title;
            }
        });
    }

    ngOnInit(): void {
    }

    goTo(section: string) {
        this.router.navigateByUrl(section);
    }

}
